import classnames from 'classnames';
import React from 'react';
import styles from './scrollbar-wrapper.scss';
export const ScrollbarWrapper = ({ className, dataHook, children, }) => (React.createElement("div", { "data-hook": dataHook, className: classnames(styles['scrollbar-wrapper'], className) }, children));
//# sourceMappingURL=scrollbar-wrapper.js.map